import Swal from 'sweetalert2';
window.Swal = Swal;

import './agendamento.js';
import './pagamento-plano.js';
